import { runDemo } from "../shared/demoRunner";
import { createFireMaterialScene } from "./scene";

runDemo({ createScene: createFireMaterialScene });
